import { auth } from '@/utils/firebase';

const endpoint = `${process.env.REACT_APP_FOLIO_ADMIN_API_ENDPOINT}/v1/search/clients`;

export const adminClientSearch = {
	search: async (requests) => {
		const token = await auth.currentUser?.getIdToken();
		const response = await fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(token ? { Authorization: token } : {}),
			},
			body: JSON.stringify({ requests }),
		});

		if (!response.ok) {
			throw new Error(`Admin client search failed with status ${response.status}`);
		}

		return response.json();
	},
};
